// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"336fba09","388":"9cbee412","535":"568a1150","539":"7e2313e2","586":"4a38bead","597":"4679784a","682":"13a50518"}[chunkId] + ".chunk.js";
};